<template>
  <ODialog ref="dialog" :maxWidth="600">
    <v-card v-if="row != null">
      <v-toolbar class="card-bar">
        <v-toolbar-title>
          Audio Message
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$refs.dialog.$dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-3 children-ma-3 v-row">
        <div>
          <v-text-field v-model="row.name" label="Nome" hide-details required />
        </div>
        <div class="grey lighten-5 pa-3">
          <div class="h-row">
            Arquivo: {{ row.size }} bytes
            <v-spacer />
            <v-btn text @click="download">
              <v-icon>download</v-icon>
              Download
            </v-btn>
            <v-btn text class="ml-2" @click="upload">
              <v-icon>upload</v-icon>
              Upload
            </v-btn>
          </div>
        </div>
        <v-alert
          v-if="fileDirty"
          dense
          icon="mdi-alert-circle"
          color="orange"
          outlined
        >
          O arquivo foi alterado. Não esqueça de clicar "Salvar" para gravar as
          alterações.
        </v-alert>
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @apply="apply"
        @cancel="dismiss"
        @delete="remove"
        :show-delete="row.id != null"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { AudioMessage } from '@/models'
import { saveBlobAs, openBlob, letters } from 'oderon-vue/utils'

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    ODialog: require('oderon-vue/cpts/ODialog').default,
    ODialogButtons: require('oderon-vue/cpts/ODialogButtons').default
  },
  data() {
    return this.reset()
  },
  methods: {
    reset() {
      return {
        row: null,
        fileDirty: false
      }
    },

    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      if (this.id != null) {
        let row = await AudioMessage.findById(this.id)
        this.row = row
        this.fileDirty = false
      } else {
        this.row = { size: 0 }
        this.fileDirty = false
      }
    },

    async download() {
      let blob = await AudioMessage.getBlob(this.id)
      let deburred = letters(this.row.name)
      saveBlobAs(blob, `audiomessage-${deburred}.bin`)
    },

    async upload() {
      let blob = await openBlob()
      this.row.size = blob.size
      this.row.blob = blob
      this.fileDirty = true
    },

    apply() {
      let data = new FormData()
      let add = (field, val) => {
        if (val) data.append(field, val)
      }

      add('name', this.row.name)
      add('id', +this.row.id)
      add('file', this.row.blob)

      this.$refs.dialog.$apply(data)
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    remove() {
      this.$refs.dialog.$apply('DELETE')
    }
  }
}
</script>

<style></style>
